import React, { FunctionComponent } from 'react';
import { isArray } from '@/utils/isArray';
import { Col, Container, Row } from '@visalex/core';

import { StartOption as StartOptionProps } from '../../VisaPage';
import StartOption from '../ListItem/StartOption';

import styles from './StartOptionsSection.module.scss';

type StartOptionsSectionProps = {
  title: string;
  startOptions: StartOptionProps[];
};

const StartOptionsSection: FunctionComponent<StartOptionsSectionProps> = ({ title, startOptions }) => {
  return (
    <section className={styles['start-options-section']}>
      <Container>
        <Row>
          <Col>
            <h3 className="option-title">{title}</h3>
          </Col>
        </Row>
        <Row>
          {isArray(startOptions) &&
            startOptions.map((option, key) => (
              <Col xs={12} sm={4} key={key} className={styles['start-option']}>
                <StartOption {...option} />
              </Col>
            ))}
        </Row>
      </Container>
    </section>
  );
};

export default StartOptionsSection;
